<template>
    <div class="profile-wrapper">

        <div class="top-action">
            <button @click="goHome">← Volver</button>
        </div>

        <div class="profile-container">

            <ProfileCard :banner="profile?.imagen_banner">

                <!-- AVATAR -->
                <template #avatar>
                    <img v-if="profile.imagen_perfil" :src="getImage(profile.imagen_perfil)" class="avatar-img" />
                    <span v-else>
                        {{ initials }}
                    </span>
                </template>

                <!-- INFO -->
                <div class="info-block">
                    <h3 class="name">
                        {{ profile.nombre }}
                    </h3>

                    <p class="role">
                        {{ profile.cargo }}
                    </p>

                    <p class="title">
                        {{ profile.profesion }} - {{ profile.institucion }}
                    </p>

                    <p class="location">
                        <MapPin class="location-icon" />
                        {{ profile.ubicacion }}
                    </p>
                </div>

                <!-- BIO -->
                <div class="bio">
                    {{ profile.descripcion }}
                </div>

                <!-- TAGS -->
                <div class="tags-block">
                    <p class="tags-title">Especialidades</p>
                    <div class="tags">
                        <TagBadge v-for="tag in profile.cualidades || []" :key="tag" :label="tag" />
                    </div>
                </div>

                <BrochureCard v-if="profile.presentacion || profile.presentaciones?.length" :file="profile.presentacion"
                    :files="profile.presentaciones" :baseUrl="$apiImgWeb" />

                <!-- CONTACT -->
                <div class="contact-block">
                    <ContactLink v-for="(red, i) in redesFiltradas" :key="i" :type="red.tipo" :label="getLabel(red)"
                        :value="red.valor" :href="getHref(red)" :icon="getImage(red.icono)" />
                </div>

                <!-- BUTTONS -->
                <div class="actions">
                    <PrimaryButton @click="handleDownloadVCard">
                        Descargar Contacto
                    </PrimaryButton>
                    <SecondaryButton @click="handleAddToWallet">
                        Agregar a billetera de Google
                    </SecondaryButton>
                </div>

            </ProfileCard>

            <!-- FOOTER -->
            <div class="footer">
                © 2026 {{ profile.nombre || 'Usuario' }}
            </div>

        </div>

    </div>
</template>

<script>
import ProfileCard from './components/ProfileCard.vue'
import PrimaryButton from './components/PrimaryButton.vue'
import SecondaryButton from './components/SecondaryButton.vue'
import TagBadge from './components/TagBadge.vue'
import ContactLink from './components/ContactLink.vue'
import BrochureCard from './components/BrochureCard.vue'
import { updateMetaTags } from '../../metaUtils';
import { MapPin } from 'lucide-vue-next'

export default {
    name: 'ProfilePage',

    components: {
        ProfileCard,
        PrimaryButton,
        SecondaryButton,
        TagBadge,
        ContactLink,
        BrochureCard,
        MapPin
    },

    data() {
        return {
            copied: false,
            profile: {
                cualidades: [],
                redes: [],
                presentaciones: [
                    'assets/files/mi_presentacion_final.pdf',
                    'assets/files/cv_alberto_2026.docx',
                    'assets/files/reporte_general.pptx',
                    'assets/files/reporte_geasdasdneral.pptx',
                    'assets/files/reporte_gedasdaneral.pptx'
                ]
            },

        }
    },

    computed: {
        initials() {
            if (!this.profile.nombre) return ''
            return this.profile.nombre
                .split(' ')
                .map(n => n[0])
                .join('')
                .substring(0, 2)
                .toUpperCase()
        },

        redesFiltradas() {
            return (this.profile.redes || []).filter(red => red && red.valor)
        }
    },

    mounted() {
        this.cargarPerfil()
    },

    methods: {

        cargarPerfil() {
            const slug = this.$route.params.slug

            fetch(`${this.$apiUrl}/buscar-tarjeta-presentacion/${slug}`)
                .then((response) => response.json())
                .then((data) => {
                    console.log('DATA:', data)

                    if (!data?.data) return

                    this.profile = {
                        ...this.profile,
                        ...data.data
                    }
                    this.updateMeta()
                })
                .catch((error) => {
                    console.error('Error al cargar perfil:', error)
                })
        },

        updateMeta() {
            const slug = this.$route.params.slug

            const meta = {
                title: `Mylcom - ${this.profile?.nombre || 'Perfil'}`,
                description: this.profile?.descripcion || '',
                canonical: `${window.location.origin}/colaboradores/info/${slug}`
            }

            updateMetaTags({ meta })
        },

        async handleAddToWallet() {
            try {
                const slug = this.$route.params.slug

                const response = await fetch(
                    `${this.$apiUrl}/cards/google-wallet/${slug}`
                )

                const data = await response.json()

                console.log('WALLET:', data)

                if (!data?.data) {
                    console.error('No hay link de wallet')
                    return
                }
                window.location.href = data.data

            } catch (error) {
                console.error('Error wallet:', error)
            }
        },

        getImage(path) {
            if (!path) return ''
            return `${this.$apiImgWeb}/${path.replace('assets/', '')}`
        },

        getLabel(red) {
            if (!red) return ''

            const labels = {
                whatsapp: 'WhatsApp',
                email: 'Correo',
                linkedin: 'LinkedIn',
                web: 'Sitio Web'
            }

            return labels[red.tipo] || red.tipo
        },

        getHref(red) {
            if (!red || !red.valor) return '#'

            switch (red.tipo) {
                case 'whatsapp':
                    return `https://wa.me/51${red.valor}`

                case 'email':
                    return `mailto:${red.valor}`

                case 'linkedin':
                    return red.valor.startsWith('http')
                        ? red.valor
                        : `https://linkedin.com/in/${red.valor}`

                case 'web':
                case 'globe':
                    return red.valor.startsWith('http')
                        ? red.valor
                        : `https://${red.valor}`

                default:
                    return red.valor
            }
        },

        handleExchangeContact() {
            this.copied = true
            setTimeout(() => (this.copied = false), 2000)
        },

        handleDownloadVCard() {

            const p = this.profile

            const phone = this.getPhone()

            const vcard = [
                'BEGIN:VCARD',
                'VERSION:3.0',
                `FN:${p.nombre || ''}`,
                `ORG:${p.institucion || ''}`,
                `TITLE:${p.cargo || ''}`,
                `TEL;TYPE=CELL:+51${phone}`,
                `EMAIL:${this.getEmail()}`,
                `ADR:${p.ubicacion || ''}`,
                `NOTE:${p.descripcion || ''}`,
                'END:VCARD'
            ].join('\n')

            const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' })

            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = `${p.nombre || 'contacto'}.vcf`

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },

        getPhone() {
            const phone = this.profile.redes?.find(r =>
                (r.tipo || '').toLowerCase() === 'whatsapp'
            )

            if (!phone || !phone.valor) return ''

            const clean = phone.valor.replace(/\D/g, '')

            return clean.startsWith('51') ? clean.slice(2) : clean
        },

        getEmail() {
            const email = this.profile.redes?.find(r =>
                (r.tipo || '').toLowerCase() === 'email'
            )

            return email?.valor || ''
        },

        goHome() {
            this.$router.push({ name: 'HomePage' })
        }
    }
}
</script>

<style scoped>
.profile-wrapper {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: clamp(16px, 4vw, 40px);
    background: #f4f6f8;
}

.profile-container {
    width: 100%;
    max-width: clamp(320px, 90vw, 480px);
}

.top-action {
    width: 100%;
    max-width: clamp(320px, 90vw, 480px);
    margin-bottom: 8px;
}

.top-action button {
    background: none;
    border: none;
    font-size: 13px;
    color: #4d9ec1;
    cursor: pointer;
    padding: 4px 0;
}

.top-action button:hover {
    text-decoration: underline;
}

.info-block {
    text-align: center;
    margin-bottom: 10px;
}

.name {
    font-size: clamp(18px, 2.5vw, 24px);
    /* 👈 adaptable */
    font-weight: 700;
    color: #262626;
    margin: 0;
}

.role {
    font-size: 13px;
    color: #4d9ec1;
    font-weight: 600;
    margin: 2px 0;
}

.title,
.location {
    font-size: 12px;
    color: #787878;
    margin: 0;
}

/* 🔥 BIO */
.bio {
    font-size: 12px;
    text-align: center;
    color: #555;
    margin-bottom: 12px;
}

/* 🔥 TAGS */
.tags-block {
    text-align: center;
    margin-bottom: 12px;
}

.tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
}

.contact-block {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 12px;
}

.actions {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.footer {
    margin-top: 12px;
    font-size: 10px;
    color: #aaa;
    text-align: center;
}

.location {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    font-size: 11.5px;
    color: #8b8b8b;
    margin: 0;
}

.location-icon {
    width: 15px;
    height: 15px;
    color: #f82003;
    flex-shrink: 0;
    transform: translateY(-0.5px);
}
</style>